<script>
import baseMixin from '@/mixins/baseMixin'
import EmptyStateBlock from '../general/empty-state-block.vue'

export default {
  name: 'FileUnableToPreviewBlock',
  components: { EmptyStateBlock },
  mixins: [baseMixin],
  props: {
    blobUrl: {
      type: String,
      required: true,
    },
    withinCard: {
      type: Boolean,
    },
  },
  computed: {
    compIconColor() {
      if (this.withinCard) {
        return this.isDarkMode ? 'white' : 'primary'
      }
      return 'white'
    },
    compTextColor() {
      if (this.withinCard) {
        return this.isDarkMode ? 'white--text' : ''
      }
      return 'white--text'
    },
  },
}
</script>

<template>
  <EmptyStateBlock>
    <template v-slot:icon>
      <v-icon :color="compIconColor" class="mb-5" size="62">
        mdi-file-question
      </v-icon>
    </template>

    <template v-slot:title>
      <h2 :class="['mb-2 font-weight-medium', compTextColor]">{{
        $t('files.unableToPreviewText')
      }}</h2>
    </template>

    <template v-slot:description>
      <p :class="['text-subtitle-1', compTextColor]">{{
        $t('files.unableToPreviewDescription')
      }}</p>
    </template>
    <template v-slot:button>
      <section class="mt-4">
        <v-btn
          data-testid="file-unable-to-preview-block-download-btn"
          color="primary"
          :class="[compTextColor]"
          depressed
          large
          :target="isSmallOrLower ? '_blank' : null"
          :href="isSmallOrLower ? blobUrl : null"
          @click="isSmallOrLower ? null : $emit('download')"
        >
          <v-icon left> mdi-file-download-outline </v-icon>
          {{ $t('general.downloadBtnText') }}
        </v-btn>
      </section>
    </template>
  </EmptyStateBlock>
</template>
